/**
 * Сообщения чата матча (функция только локальной разработки, см. ChatPanel):
 * общие правила для клиента, MCP-агентов (server/mcp) и сервера.
 */

// Предельная длина одного сообщения — одна и та же у живого игрока и агента
export const CHAT_MESSAGE_MAX_LENGTH = 2000;

// Текст к отправке: без пробелов по краям и не длиннее предела. Пустая строка —
// отправлять нечего
export const normalizeChatMessageText = (text) => (
  typeof text === 'string' ? text.trim().slice(0, CHAT_MESSAGE_MAX_LENGTH) : ''
);

/**
 * Можно ли принять сообщение чата, пришедшее от игрока по RELAY_ACTION.
 * Писать может только участник матча и только от своего имени: запись матча
 * и память агентов опираются на автора сообщения, а зритель или чужой клиент
 * иначе мог бы говорить за любого игрока. Текст — непустая строка в пределах
 * CHAT_MESSAGE_MAX_LENGTH (так его отправляют и интерфейс, и MCP).
 */
export const checkIfRelayedChatMessageAllowed = (action, senderPlayerId, matchPlayerIds) => {
  const payload = action?.payload;
  if (!payload || typeof payload !== 'object') {
    return false;
  }
  if (!senderPlayerId || payload.fromPlayerId !== senderPlayerId) {
    return false;
  }
  if (!(matchPlayerIds || []).includes(senderPlayerId)) {
    return false;
  }
  const {text} = payload;
  return typeof text === 'string'
    && text.trim().length > 0
    && text.length <= CHAT_MESSAGE_MAX_LENGTH;
};

/**
 * Сообщение чата в том виде, в каком его примет и разошлет сервер, или null,
 * если принимать нельзя (см. checkIfRelayedChatMessageAllowed).
 *
 * Имя автора сервер ставит сам — из состава матча (senderName), а не со слов
 * клиента: иначе участник мог бы подписаться чужим именем, а агенты читают
 * чат именно по именам (MCP get_chat_messages). Честный клиент и MCP шлют то
 * же имя из того же состава, так что у отправителя ничего не расходится.
 */
export const resolveRelayedChatMessage = (action, {senderPlayerId, matchPlayerIds, senderName}) => {
  if (!checkIfRelayedChatMessageAllowed(action, senderPlayerId, matchPlayerIds)) {
    return null;
  }
  const fromPlayerName = typeof senderName === 'string' && senderName
    ? senderName
    : String(action.payload.fromPlayerName ?? '');
  return {...action, payload: {...action.payload, fromPlayerName}};
};
